import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import Icon from '@uikit/components/Icon/Icon';
import Logo from '@uikit/components/Logo/Logo';
import clsx from 'clsx';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import styles from './RegioHeader.module.scss';
import type { RegioHeaderProps } from './types';

const RegioHeader = ({ hasMarginBottom }: RegioHeaderProps) => {
  const isMobile = useIsMobile(768);
  const iconSize = isMobile ? 'iconSize18' : 'iconSize24';

  return (
    <div
      className={clsx(styles.base, {
        [styles.hasMarginBottom]: hasMarginBottom,
      })}
    >
      <Clickable
        className={styles.link}
        actionType={ClickableAction.Linkintern}
        linkintern="/"
        aria-label="Zu enercity.de"
      >
        <Logo className={styles.logo} />
        <span className="visually-hidden">Zu enercity.de</span>
      </Clickable>
      <Clickable
        className={styles.link}
        actionType={ClickableAction.Linkintern}
        linkintern="/"
      >
        enercity.de
        <Icon variant="action/external-link" size={iconSize} />
      </Clickable>
    </div>
  );
};

export default RegioHeader;
